<div class="px-4 py-4 w-full inline-flex justify-between sm:px-6">
  <h3 class="text-2xl leading-6  text-gray-900 flex flex-wrap items-baseline gap-x-2">
    <span>Top Verkäufe des Events</span>
    @if (isIndividualGrouping()) {
      <span class="text-xs text-gray-500">Kombinationen einzeln</span>
    }
  </h3>
  <div (click)="hideMenu = !hideMenu" class="sm:hidden text-gray-950 hover:text-theme-primary-700">
    @if (hideMenu) {
      <svg class="w-6 h-6 fill-none" stroke="currentColor" stroke-width="1.5"
           viewBox="0 0 24 24"
           xmlns="http://www.w3.org/2000/svg">
        <path d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    } @else {
      <svg class="w-6 h-6 fill-none" stroke="currentColor" stroke-width="1.5"
           viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 18L18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    }
  </div>
</div>
<div>
  <div class="pt-1 sm:p-6 "></div>
  <div class=" xl:overflow-y-scroll table-window-container xl:max-h-full">
    <div class="px-4 pt-0 pb-3 h-[44rem]">
      <app-top-sales [hideMenu]="hideMenu"></app-top-sales>
    </div>
  </div>
</div>

